'use strict'

export let norwegian={
  definition:"definisjon",
  aspects: {
    time: "Tid",
    scope: "Omfang",
    cost: "Kostnad",
    quality: "Kvalitet",
    risk: "Risiko",
    scopeDescription: "Omfanget er beskrevet i separat seksjon."
  },
  background: {
    title:"Bakgrunn",
    fields: {
      background: {
        title: "Hvorfor er prosjektet satt i gang?",
        description:"Begrunnelse for organisasjonsaktiviteten (prosjekt)",
        help:`Hva er virksomhetenes behov dette prosjektet skal adressere?
          Hvilket problemet prøver vi å løse?
          Hvordan vet vi at det er et problem?
          Hvem løser vi problemet for, og hvordan vet vi at de ønsker å få løst dette udekkede behovet?`
      },
      timing: {
        title:"Hvorfor nå?",
        description:"Begrunnelse for tidspunktet",
        help:`Hva er som utløser at vi vil gjøre dette akkurat nå?
          Eventuelle eksterne omstendigheter eller interne faktorer? En ny innsikt, ny teknologi eller en ny strategi som påvirker tidspunktet for denne muligheten?`
      },
      bigPicture: {
        title: "Hvordan passer prosjektet i det store bildet?",
        description:"Beskriv hvordan prosjektet er knyttet til strategier på høyere nivå eller initiativ",
        help:`Er dette prosjektet en del av et større strategisk initiativ?
          Hvordan er det knyttet til bedriftsstrategien?`
      }
    }
  },
  objectives: {
    title: "Mål",
    fields: {
      benefitsDescription: {
        title: "Viktigste gevinster som skal oppnås",
        description:"De planlagte målbare forbedringene fra dette prosjektet som oppfattes som en fordel for en eller flere interessenter",
        help:`Hvilke målbare forbedringer vil dette prosjektet levere?
          Hvilke gevinster er mer eller mindre viktige?`
      },
      objectivesSummary: {
        title: "Resultatmål",
        description: `Dra og slipp ytelsesområdene for å plassere dem i korrekt prioritert rekkefølge.
          Hvis det ikke er noe spesifkt mål på et resultatområde, la det stå tomt. Resltatområde uten beskrivelse av mål vil ikke vises i Prosjektforslag eller Styringsdokument.`,
        help: `Hva er resultatmålene for dette prosjektet? Eventuelle ambisjoner eller begrensninger prosjektet skal bruke som innspill til planlegging?
          Tid: Hva er tidsrammen eller tidsfristen du har i tankene? - Hvorfor har du den fristen eller rammen i tankene?
          Omfang: Er omfanget stort eller lite? Hvis det er stort, hvorfor er det stort? Hvis det er lite, hvorfor er det lite?
          Kostnad: Hva ville du forvente å bruke på dette prosjektet? - Hvorfor har du dette kostnadsmålet? Hva er årsakene til det?
          Kvalitet: Hva er de viktigste kravene, standarder og forskrifter? Er noen av dem valgfrie?
          Risiko: Hva er et akseptabelt risikonivå for dette prosjektet? Hvordan er interessenternes risikoappetitt? Eventuelle spesifikke risikomål knyttet til forskrifter, klassifisert informasjon eller personvern?

          Toleranser:
          Under hvilke forhold ville vi stoppe/avslutte prosjektet?
          Hvor mye skal en prognose overstige målene og planene før prosjekteieren skal informere sine overordnede? (tid, kostnad, kvalitet)

          Prioriteringer:
          Når må avveinger gjøres, hvilken av faktorene for dette prosjektet må oppnås (dvs hva er det som ikke kan ofres)?
          Forklar konsekvensen av manglende oppfyllelse av hver av prioritetene. Etter å ha vurder det, hva er den viktigste faktoren?`,
        columns: {
          pri: { title: "Pri" },
          description: { title: "Beskrivelse av mål" },
          name: { title: "Resultatområde" },
          tolerance: { title: "Toleranse" }
        }
      },
      objectives: {
        title: "Kommentarer til målene",
        description:"Annen relevant informasjon relatert til resultatmålene for dette prosjektet"
      }
    }
  },
  scope: {
    title: "Omfang",
    fields: {
      projectScope: {
        title: "Omfang",
        description: "Dra og slipp delene av omfanget i korrekt prioritert rekkefølge",
        help: `Hva designer / lager vi?
          Ivaretar prosjektet også:
          1. Oppstart?
          2. Opplæring av brukere, kunder eller interne funksjoner?
          3. Klargjøre tjenester eller tjenestefunksjoner?
          4. Fase ut noen gamle løsninger?
          5. Migrering av data eller utstyr fra gammel løsning?
          6. Integrasjon med andre løsninger?
          7. Forberedre effektiv drift og vedlikehold?
          8. Alle brukere, geografiske områder / språk, funksjoner, segmenter?
          9. Oppfølgingsaktiviteter etter oppstart?`,
        samples: [
          { text: "Bygge eller designe noe? For en spesifikk avdeling, funksjon, geografisk område eller bruk?" },
          { text: "Forberede produksjons- eller drifsmiljø? Hvor?" },
          { text: "Forbered service- eller støttefunksjoner? Hvilke? Hvordan?" },
          { text: "Utrulling / lansering, forberede eller lære opp brukere, salgsorganisasjoner, kunder? Hvor?" }
        ],
        columns: {
          text: { title: "Del opp omfanget i separate korte beskrivelser. En per linje nedenfor." }
        }
      },
      scopeExclusions: {
        title: "Utelukkelser fra omfanget",
        description:"Beskriv hva prosjektet ikke vil levere",
        help:"Er det spesifikke ting som prosjektet ikke vil levere? Er det noen funksjoner, brukere, geografiske områder eller avdelinger som ikke er inkludert?"
      },
      outcomes: {
        title: "Forventet resultat",
        description:"Resultatet av endring, som vanligvis påvirker reell oppførsel og / eller omstendigheter.",
        help:"Hvordan vil prosjektet gjøre det mulig for organisasjonen å betjene sine kunder eller brukere bedre? Hvilke nye ting (evne) kan våre kunder (intern og ekstern) gjøre når prosjektet er ferdig?"
      }
    }
  },
  constraints: {
    title: "Begrensninger",
    fields: {
      constraints: {
        title: "Begrensninger",
        description:"Restriksjoner eller begrensninger prosjektet er bundet av",
        help:`Er det andre ting som andre prosjekter må levere inn i dette prosjektet?
          Er det noen tidligere forpliktelser eller forventninger til andre organisasjoner eller partnere som må oppfylles? Tidsforpliktelser?
          Er det noen kjente praktiske begrensninger for å gjennomføre dette prosjektet?
          1. Kunden forventer en bestemt type løsning
          2. Produktprisbegrensning
          3. Tidsbegrensning - denne muligheten er midlertidig, ettersom andre konkurrenter kan ta markedet.
          Vil det være spesielle sikkerhetsbetingelser for prosjektet? Vil prosjektet håndtere klassifisert informasjon?`
      },
      assumptions: {
        title: "Antagelser",
        description:"Hva er det som er annatt å være sant for planlegging, men som kan forandre seg senere? En antagelse er gjort for fakta som ikke er kjent enda eller besluttet.",
        help:`Er det noen antagelser om tilgang til ressurser, verktøy, teknologi eller kompetanse?
              Er det noen antagelser om datakvalitet eller utstyr i eksisterende løsning?
              Er det noen antagelser om hva andre løsninger vil dekke?`
      }
    }
  },
  stakeholders: {
    title:"Interessenter & grensesnitt",
    fields: {
      stakeholderDescription: {
        title: "Interessenter",
        description:"Brukerne og andre kjente interesserte parter",
        help:`Hvem får fordel av at prosjektet gjennomføres?
          Hvem skal bruke prosjektets produkter? (salg, sourcing, etc.)
          Hvilken kundegruppe eller avdeling er prosjektet ment å påvirke?
          Hvem vil sannsynligvis føle seg truet av dette prosjektet eller har sterke meninger?
          Hvem trenger å være fornøyd med resultatet?
          Hvem er sterke støttespillere til dette prosjektet?
          Hvilke partnere er involvert?
          Hvilke leverandører kan være involvert?`
      },
      interfaces: {
        title: "Grensesnitt",
        description:"Beskriv prosjektets grensesnitt",
        help:`Er dette prosjektet avhengig av andre prosjekter?
          Er systemet eller produktet forbundet eller fungerer sammen med andre systemer eller produkter?
          Er det noen ikke-tekniske systemer som prosjektets produkter vil trenge samhandling med gjennom deres livsyklus eller bruk?`
      }
    }
  },
  messages: {
    updateScope: "Vennligst oppdater omfang før du legger inn prosjektproduktbeskrivelsen under 'Kvalitet'.",
    deletedScope: "(slettet: vennligst fjern tilknyttede leveranser)"
  }
}



// WEBPACK FOOTER //
// ./views/definition/labels/norwegian.js